import Vue from 'vue';
import Vuex from 'vuex';
import { ExerciseState, exerciseModule } from './exercise.store';
import { RootState } from './root.store';
import { ExerciseActivityState, exerciseActivityModule } from './exercise-activity.store';

Vue.use(Vuex);

interface ModuleState {
  exercise: ExerciseState;
  exerciseActivity: ExerciseActivityState;
}

export type AppState = RootState & ModuleState;

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    exercise: exerciseModule,
    exerciseActivity: exerciseActivityModule,
  },
  getters: {},
  strict: process.env.NODE_ENV !== 'production',
});
